// eslint-disable-next-line import/prefer-default-export
export const PLATFORM: 'dev' | 'web' | 'android' | 'ios' = process.env.NODE_ENV === 'development' ? 'dev' : 'web'
